export const USER_ORDERS_REQUEST = 'USER_ORDERS_REQUEST';
export const USER_ORDERS_SUCCESS = 'USER_ORDERS_SUCCESS';
export const USER_ORDERS_FAIL = 'USER_ORDERS_FAIL';

export const ADMIN_ORDERS_REQUEST = 'ADMIN_ORDERS_REQUEST';
export const ADMIN_ORDERS_SUCCESS = 'ADMIN_ORDERS_SUCCESS';
export const ADMIN_ORDERS_FAIL = 'ADMIN_ORDERS_FAIL';

export const CLEAR_ERRORS = 'CLEAR_ERRORS'